<div class="step-content-title">
  <my-signup-mascot [imageName]="mascotImageName"></my-signup-mascot>

  <h2>
    <ng-content></ng-content>
  </h2>

  <div class="step-content-title-separator"></div>
</div>
